export class StudioOptionsModel {
  public id: string;

  constructor(
    public label: string,
    public value: string | number,
    public type: 'category' | 'collection' | 'user',
    public organizationId: number = null
  ) {
    this.id = `${type}|${value || ''}|${organizationId || ''}`;
  }
}
